module.exports = __webpack_public_path__ + "static/media/natural-stone-base-background.20038c9d.jpg";